import { PlusIcon } from "@images/svgIcons/plusIcon"
import { word } from "@modules/core/utils/i18n"
import { ChronoRecap } from "@modules/sessionBlock/exercises/components/chronoRecap"
import { ExerciseFormikType } from "@modules/sessionBlock/exercises/exerciseFormikTypes"
import { useSessionFormContext } from "@modules/sessions/hooks/useSessionFormContext"
import { useSessionSidebar } from "@modules/sessions/hooks/useSessionSidebar"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

export const ChronoBloc: React.FC = () => {
  const { navigateToChronoForm } = useSessionSidebar()
  const { formik, updatedBlockIndex } = useSessionFormContext()
  const theme = useTheme()

  const formikValue =
    updatedBlockIndex !== null ? (formik.values.blocks[updatedBlockIndex].content as ExerciseFormikType) : null

  if (updatedBlockIndex === null) return <></>

  const addChrono = () => {
    navigateToChronoForm()
  }

  return (
    <div
      className={`mb-0 flex w-full ${formikValue?.chronoType && formikValue.chronoType !== "NONE" ? "flex-column" : ""}`}
    >
      {formikValue?.chronoType && formikValue.chronoType !== "NONE" ? (
        <ChronoRecap />
      ) : (
        <div className="card mt-2 w-full flex flex-row justify-content-start align-items-center py-3 px-4 gap-3">
          <div
            onClick={addChrono}
            className="rounded-full flex justify-content-center align-items-center bg-neutralColor-200 hover:surface-300 transition-duration-300 transition-all cursor-pointer"
            style={{ height: 40, width: 40 }}
          >
            <PlusIcon color={theme.neutralColor700} />
          </div>
          <div className="flex flex-column align-items-start">
            <HUText className="my-1" fontStyle="LL">
              {word("program.planning.create.exercise.addChrono.title")}
            </HUText>
            <HUText className="text-center my-1" fontStyle="BS" color={theme.neutralColor600}>
              {word("program.planning.create.exercise.addChrono.description")}
            </HUText>
          </div>
        </div>
      )}
    </div>
  )
}
